/* unplugin-vue-components disabled */import script from "./CinemaRecentPlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./CinemaRecentPlay.vue?vue&type=script&lang=ts&setup=true"

import "./CinemaRecentPlay.vue?vue&type=style&index=0&id=25dc6855&lang=scss"

const __exports__ = script;

export default __exports__